import Dashboard from './components';

export default Dashboard;
